import { Injectable } from '@angular/core';
import { ToastrService, GlobalConfig } from 'ngx-toastr';
import {Howl, Howler} from 'howler';

@Injectable()
export class AlertService {

  private options: GlobalConfig;
  private sound = new Howl({
    src: ['assets/alert2.wav']
  });

  private sound2 = new Howl({
    src: ['assets/alertSuccess.flac']
  });

  constructor(private toastr: ToastrService) {
    this.options = this.toastr.toastrConfig;
    this.options.timeOut = 7000;
  }

  public generateAlertError(mensaje, titulo, opciones?) {
    this.options.messageClass = 'toast-error';
    opciones = this.options;
    this.toastr.error(mensaje, titulo, opciones);
    this.sound.play();

  }
  public generateAlertSuccess(mensaje, titulo, opciones?) {
    this.options.messageClass = 'toast-success';
    opciones = this.options;
    this.toastr.success(mensaje, titulo, opciones);
    this.sound2.play();

  }
  public generateAlertInfo(mensaje, titulo, opciones?) {
    this.options.messageClass = 'toast-info';
    opciones = this.options;
    this.toastr.info(mensaje, titulo, opciones);
    this.sound.play();
  }
}
